import { DashboardWidgetType } from '../enums/DashboardWidgetType';

export const dashboardNotAvailableWidgetTypes = [DashboardWidgetType.IPOPoll];
export const dashboardAvailableWidgetTypes = Object.values(DashboardWidgetType).filter(
  type => !dashboardNotAvailableWidgetTypes.includes(type),
);
